<div class="p-r-1 p-l-1 p-r-2-m p-r-2-s p-l-2-m p-l-2-s col-w bg-col-21 b-radius-4 _label"
     [sizeClass]="'S: p1,!S: p2'">
    -{{ discountPercentage }}%
</div>
